/* eslint-disable */ 

import React from 'react'
import { CFooter } from '@coreui/react'

import { signOut } from 'firebase/auth'
import { auth } from '../firebase'

const AppFooter = () => {

  // function to logout
  const logout = () => {
    signOut(auth)
  }

  return (
    <CFooter>
      <div>
        <a href="https://www.orian.co.uk" target="_blank" rel="noopener noreferrer">
          Orian Desk
        </a>
        <span className="ms-1">&copy; 2022 Orian Solutions LTD</span>
      </div>
       <div className="ms-auto">
        <a href="#" onClick={() => {logout()}}>
          Logout
        </a>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
